import React, { useState } from "react";
import { Link } from "react-router-dom";
import menus from "../../data/menus.json";
import { useLocation } from "react-router-dom";

export default function DrawerMobile() {
  const [state, setState] = useState({ status: "open" });
  const location = useLocation();

  const toggleDrawer = () => {
    if (state.status === "close") setState({ status: "open" });
    else setState({ status: "close" });
  };

  let menuEl = [];
  menus.forEach((x) => {
    menuEl.push(
      <Link key={x.path} to={x.path}>
        <div className={x.path === location.pathname ? "selected" : ""}>
          {state.status === "close" ? x.showName : x.name}
        </div>
      </Link>
    );
  });

  return (
    <nav className="drawer-mobile">
      <div className="flex justify-center">
        <div
          className="w-[20px] h-[20px] mx-3 bg-menu bg-no-repeat bg-center bg-contain"
          onClick={toggleDrawer}
        ></div>
      </div>
      {menuEl}
    </nav>
  );
}
